import { render, staticRenderFns } from "./prepStationBig.vue?vue&type=template&id=d8c10ef2&scoped=true&lang=pug"
import script from "./prepStationBig.vue?vue&type=script&lang=js"
export * from "./prepStationBig.vue?vue&type=script&lang=js"
import style0 from "./prepStationBig.vue?vue&type=style&index=0&id=d8c10ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c10ef2",
  null
  
)

export default component.exports